import { setSearch } from "@/tracker/shared/global";
import { isArray } from "lodash";
import searchTracker from "../tracker/report/searchTracker";
import request from "../utils/request";

/**
 * 搜索联想词接口
 * @param {{
 *  q: string,
 *  limit?: number | 10
 * }} query
 * @param query.q 搜索词
 * @param query.limit 返回最多的结果数量
 * @returns {Promise<{result:string[], total:number, material_count: number}>}
 */
export async function getAssociate(query) {
  return request({
    url: "/search/hint",
    query: { limit: 10, ...query },
  });
}

/**
 * 搜索采集
 * @param {{
 *  q: string,
 *  colors: string
 *  sort: string,
 *  category: number
 *  per_page: number
 *  page: number
 * }} query
 * @returns {Promise<{result:[], total:number}>}
 */
export async function getSearchPins(query) {
  const result = await request({
    url: "/search",
    query,
  });

  if (query.page === 1) {
    // const { facets } = result;
    // facets.categories
    searchTracker({
      search_word: query.q,
      search_result_number: result.pin_count || result.facets?.total || 0,
      sort_type: query.sort,
      colors: query.colors,
    });
  }

  return result;
}
// 获取搜索采集筛选器
export async function getSearchPinsFilterByQingzhou(query) {
  return request({
    url: "/search/filter",
    query,
  });
}

/**
 * 通过筛选器搜索采集
 * @param {{
 *  text?: string;
 *  colors?: string;
 * sort?: string;
 * filter_ids?: string[];
 * page: number;
 * limit?: number;
 * position?: string; // 位置,搜索结果页_采集  search_pin 搜索结果页_花瓣素材  search_material 主题页 topics
 * all_match?: boolean; // 是否全匹配 默认是全匹配(true)
 * }} param0
 * @returns {Promise<{pins:IPin[], topics: ITopic[], facets: {total:number}, total?:number}>}
 */
export async function getSearchPinsByQingzhou({ colors, ...query }) {
  const result = await request({
    url: "/search/file",
    query: {
      ...query,
      fields:
        "pins:PIN|total,facets,split_words,relations,rec_topic_material,topics",
    },
  });

  if (query.page === 1) {
    setSearch({
      filter_ids: query?.filter_ids || [],
    });

    searchTracker({
      search_word: query.text,
      search_result_number: result.total || result.facets?.total || 0,
      sort_type: query.sort,
      colors,
    });
  }

  return result;
}

/**
 * 搜索画板
 * @param {{
 *  q: string,
 *  colors: string
 *  sort: string,
 *  category: number
 *  per_page: number
 *  page: number
 * }} query
 * @returns {Promise<{result:[], total:number}>}
 */
export async function getSearchBoards(query) {
  const result = await request({
    url: "/search/boards",
    query: {
      ...query,
      fields: "boards:BOARD|facets|board_count",
    },
  });

  if (query.page === 1) {
    // const { facets } = result;
    // facets.categories
    searchTracker({
      search_word: query.q,
      search_result_number: result.board_count || result.facets?.total || 0,
      sort_type: query.sort,
      colors: query.colors,
    });
  }

  return result;
}

/**
 * 搜索用户
 * @param {{
 *  q: string,
 *  colors: string
 *  sort: string,
 *  category: number
 *  per_page: number
 *  page: number
 * }} query
 * @returns {Promise<{result:[], total:number}>}
 */
export async function getSearchUsers(query) {
  return request({
    url: "/search/people",
    query,
  });
}

/**
 * 搜索我的采集
 * @param {{
 *  q: string,
 *  colors: string
 *  sort: string,
 *  category: number
 *  per_page: number
 *  page: number
 * }} query
 * @returns {Promise<{result:[], total:number}>}
 */
export async function getSearchMyPins(query) {
  const result = await request({
    url: "/search/self_pins",
    query,
  });

  if (query.page === 1) {
    // const { facets } = result;
    // facets.categories
    searchTracker({
      search_word: query.q,
      search_result_number: result.total_count || 0,
      sort_type: query.sort,
      colors: query.colors,
      filter_one: ["我的采集"],
    });
  }

  return result;
}

/**
 * 搜索我的画板
 * @param {{
 *  q: string,
 *  colors: string
 *  sort: string,
 *  category: number
 *  per_page: number
 *  page: number
 * }} query
 * @returns {Promise<{result:[], total:number}>}
 */
export async function getSearchMyBoards(query) {
  const result = await request({
    url: "/search/self_boards",
    query,
  });

  if (query.page === 1) {
    // const { facets } = result;
    // facets.categories
    searchTracker({
      search_word: query.q,
      search_result_number: result.total_count || 0,
      sort_type: query.sort,
      colors: query.colors,
      filter_one: ["我的画板"],
    });
  }

  return result;
}

/**
 * 搜索其他人采集
 * @param {{
 *  q: string,
 *  colors: string
 *  sort: string,
 *  category: number
 *  per_page: number
 *  page: number
 * }} query
 * @returns {Promise<{result:[], total:number}>}
 */
export async function getSearchOtherPins({ q, urlname, page, per_page }) {
  const result = await request({
    url: `/${urlname}/pins`,
    query: {
      q,
      page,
      per_page,
      fields: "pins:PIN|total,page_num,page_size",
    },
  });

  if (page === 1) {
    // const { facets } = result;
    // facets.categories
    searchTracker({
      search_word: q,
      search_result_number: result.total_count || 0,
      filter_one: ["他的采集"],
    });
  }

  return result;
}

/**
 * 搜索画板内采集
 * @param {{
 *  q: string,
 *  colors: string
 *  sort: string,
 *  category: number
 *  per_page: number
 *  page: number
 * }} query
 * @returns {Promise<{result:[], total:number}>}
 */
export async function getSearchBoardPins({
  q,
  user_id,
  board_id,
  page,
  per_page,
  file_type,
  colors,
  resolution,
  ...query
}) {
  const result = await request({
    url: `/users/${user_id}/pins`,
    query: {
      q,
      board_id,
      file_type,
      colors,
      resolution,
      page,
      per_page,
      ...query,
    },
  });

  if (page === 1) {
    // const { facets } = result;
    // facets.categories
    searchTracker({
      search_word: q,
      search_result_number: result.total_count || 0,
      filter_one: ["画板内采集"],
    });
  }

  return result;
}

/**
 * 搜索来源内采集
 * @param {{
 *  q: string
 *  max: number
 *  since: number
 *  limit: number
 *  domain_id: number
 * }} query
 * @returns {Promise<{result:[], total:number}>}
 */
export async function getSearchDomainPins({ q, per_page, page, domain_id }) {
  const result = await request({
    url: `/domains/${domain_id}/pins`,
    query: {
      q,
      per_page,
      page,
      domain_id,
    },
  });

  if (page === 1) {
    // const { facets } = result;
    // facets.categories
    searchTracker({
      search_word: q,
      search_result_number: result.total_count || 0,
      filter_one: ["来源内采集"],
    });
  }

  return result;
}

/**
 * 搜索其他人画板
 * @param {{
 *  q: string,
 *  colors: string
 *  sort: string,
 *  category: number
 *  per_page: number
 *  page: number
 * }} query
 * @returns {Promise<{result:[], total:number}>}
 */
export async function getSearchOtherBoards({ q, urlname, page, limit }) {
  const result = await request({
    url: `/${urlname}/boards`,
    query: {
      q,
      page,
      limit,
      fields: "boards:BOARD|user,total,page_num,page_size",
    },
  });

  if (page === 1) {
    // const { facets } = result;
    // facets.categories
    searchTracker({
      search_word: q,
      search_result_number: result.total_count || 0,
      filter_one: ["他的画板"],
    });
  }

  return result;
}

/**
 * @returns {Promise<{word: string, score: number}[]>}
 */
export function getSearchHotWord() {
  return request({
    url: "/search-words/hot",
  });
}

/**
 * 获取搜索占位词
 * @returns
 */
export function getSearchPlaceholder(query) {
  return request({
    query: {
      word_type: "PLACEHOLDER_WORD",
      ...query,
    },
    url: "/search-word-interventions/hit-words",
  });
}

/**
 * 筛选器预览信息(批量获取)
 * @param {{
 *   preview_limit: number
 *   filter_ids: number|string[] | string
 * }} query
 * @returns
 */
export function getTopicsPreview({ preview_limit, filter_ids }) {
  return request({
    url: "/search/filters/preview",
    query: {
      preview_limit,
      filter_ids: isArray(filter_ids) ? filter_ids.join(",") : filter_ids,
    },
  });
}
